// import Swal from 'sweetalert2';
// import "./SwalStyleCss.css";
// const CustomSwal = ({ title, text, footer, onConfirm, onCancel, confirmButtonText, cancelButtonText, closeButtonText }) => {
//     Swal.fire({
//         title: title,
//         text: text,
//         footer: footer,
//         icon: 'warning',
//         showCancelButton: true,
//         showCloseButton: true,
//         confirmButtonText: confirmButtonText || 'Ok',
//         cancelButtonText: cancelButtonText || 'Cancel',
//         closeButtonText: closeButtonText || 'Close',
//         reverseButtons: true,
//         customClass: {
//             confirmButtonText: 'custom-swal-confirm',
//             cancelButtonText: 'custom-swal-cancel',
//             closeButtonText: 'custom-swal-close',
//         },
//     }).then((result) => {
//         if (result.isConfirmed) {
//             onConfirm(); // Call the confirm handler
//         } else if (result.dismiss === Swal.DismissReason.cancel) {
//             onCancel(); // Call the cancel handler
//         }
//     });
// };

// export default CustomSwal;



import Swal from 'sweetalert2';
import "./SwalStyleCss.css";

const CustomSwal = ({
  title,
  text,
  html,
  footer,
  onConfirm,
  onCancel,
  confirmButtonText,
  cancelButtonText,
  closeButtonText,
  preConfirm,
  focusConfirm
}) => {
  Swal.fire({
    title,
    text,
    html, // ✅ IMPORTANT
    footer,
    icon: 'warning',
    showCancelButton: true,
    showCloseButton: true,
    confirmButtonText: confirmButtonText || 'Ok',
    cancelButtonText: cancelButtonText || 'Cancel',
    closeButtonText: closeButtonText || 'Close',
    reverseButtons: true,
    focusConfirm: focusConfirm ?? true,
    preConfirm, // ✅ IMPORTANT
    customClass: {
      confirmButton: 'custom-swal-confirm',
      cancelButton: 'custom-swal-cancel',
      closeButton: 'custom-swal-close',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm && onConfirm(result.value); // ✅ pass value back
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      onCancel && onCancel();
    }
  });
};

export default CustomSwal;